import { CommonKVMessage } from "../../types";
import { EventBody, MessageComponent, MessageComponentProps } from "./Message";
import { HighlightedText } from "../../agent/stateComponents/SimpleComponentVisualization";

const KVMessage: MessageComponent<CommonKVMessage> = ({
  message,
  textFilter,
}: MessageComponentProps<CommonKVMessage>) => {
  return (
    <>
      <h6>
        <code>
          <HighlightedText text={message.key ?? ""} textFilter={textFilter} />
        </code>
      </h6>
      <EventBody>
        <HighlightedText
          text={message.value == null ? "" : String(message.value)}
          textFilter={textFilter}
        />
      </EventBody>
    </>
  );
};

export default KVMessage;
